// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"cdb456d3","404":"a6906c59","424":"495ead55","640":"1ee90943","735":"a9a83a5f","762":"1b998f3c","779":"69302c75","785":"cc2473c9","907":"95230659","972":"0f7d2d38","991":"fbb3e2af"}[chunkId] + ".chunk.js";
};